import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
class EdPaginationFooterComponent extends Vue {

  @Prop() readonly seeMore: boolean;
  @Prop() readonly loading: boolean;
  @Prop() readonly error: boolean;

  public readonly onGetMore: string = 'onGetMore';

  getMore() {
    this.$emit(this.onGetMore);
  }

}

export default Vue.component(
  'ed-pagination-footer', EdPaginationFooterComponent);